import { REACT_APP_QUOTATION_API_URL, REACT_APP_QUOTATION_API_KEY } from 'config';
import { QuotationResult } from './types';
import * as Sentry from '@sentry/react';

export const getQuotation = async (token: string): Promise<QuotationResult> => {
    try {
        const response = await fetch(`${REACT_APP_QUOTATION_API_URL}/api-quotation/v1/quotations/promotion?id_quotation=${token}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': REACT_APP_QUOTATION_API_KEY,
                'x-user': 'ole-web-application',
            },
        });

        if (!response.ok) {
            Sentry.logger.error('quotationService[getQuotation] error', {
                status: response.status,
            });
            return {
                success: false,
                error: {
                    message: `Failed to get quotation: ${response.statusText}`,
                    code: `${response.status}`,
                    status: response.status,
                },
            };
        }

        const data = await response.json();
        Sentry.logger.info('quotationService[getQuotation]', {});
        return data as QuotationResult;
    } catch (error) {
        Sentry.logger.error('quotationService[getQuotation] unexpected error', { error });
        return {
            success: false,
            error: {
                message: `Unexpected error: ${error}`,
                code: 'NETWORK_ERROR',
            },
        };
    }
};
